export interface IKeyWord {
  keyWordId: string;
  keyWordString: string;
}

export interface IdefinitionId {
  defId: string;
  labelId: string;
}

export interface IAltLabelForKeyword {
  content: string;
  element: Element;
  id: string;
  isPreferedLabel?: boolean;
}

export interface IEditKeyWord {
  keyWordId: string;
  definition: string;
  keyWord: string;
}

export interface IKeywordDefinition {
  /**
   * Keyword id
   *
   * @type {string}
   */
  id: string;
  /**
   * use for sort in order
   * name is text content of keyTerm (html)
   *
   * @type {string}
   */
  name: string;
  /**
   * Keyterm/keyword is define by user after selecting text from document
   *
   * @type {string}
   */
  keyTerm: string;

  /**
   * definition is description of Keyterm/keyword
   *
   * @type {string}
   */
  definition: string;

  /**
   * altLabels define same definition
   * Just like keyterm/keyword in document but not displing in right hand panel
   *
   * @type {?IAltLabelForKeyword[]}
   */
  altLabels?: IAltLabelForKeyword[];

  /**
   * Prefered label id indicate first create keyword lable against defination
   *
   * @type {string}
   */
  preferedLabelId: string;

  /**
   * Count of alternate labels used to hide / show chevrons in right hand panel
   *
   * @type {string}
   */
  altLabelsCount?: number;
}

export type SelectedKeywordType = IKeywordDefinition | string | undefined;

export type KeywordTraverse = ITraverseKeyword | string | undefined;
export interface ITraverseKeyword {
  keyword: IKeywordDefinition;
  idToSelect: string;
}

export interface ICopyKeyword {
  isCopy: boolean;
  keyword: IKeywordDefinition;
  event?: any;
}

export interface IKeywordDefinitionWithUnwrapFlag {
  keyword: IKeywordDefinition;
  unwrapFlag: boolean;
}

export interface IKeyWords {
  /**
 * Create for future use/If not will remove
 *
 * @type {{
    [key: string]: IKeyWord;
  }}
 */
  byId: {
    [key: string]: IKeyWord;
  };
  /**
   * Create for future use/If not will remove
   * Also we can check id exist or not
   *
   * @type {string[]}
   */
  allId: string[];
  /**
   * formattedKeyword is use to display right hand panel
   *
   * @type {IKeywordDefinition[]}
   */
  formattedKeyword: IKeywordDefinition[];
  /**
   * All keyword using fetch/post keywords,
   *
   * @type {IKeyWord[]}
   */
  allKeyword: IKeyWord[];
  /**
   * use to get selected keyword/label from document
   *
   * @type {?SelectedKeywordType}
   */
  selected?: SelectedKeywordType;
  /**
   * Use to set & get when user click on copy
   *
   * @type {?ICopyKeyword}
   */
  copyKeyword?: ICopyKeyword;
  /**
   * definition is description of Keyterm/keyword
   *
   * @type {string}
   */
  definition?: string;
  /**
   * used to get updated keyword
   *
   * @type {string}
   */
  keyword?: string;
  /**
   * used to get the Keyword selected to delete from RHP
   */
  keywordForDelete?: IKeywordDefinitionWithUnwrapFlag;

  keywordTraverse?: IKeywordDefinition;
}
